import React from "react";
import "../../styles/settings/privacyAndData.css";

const PrivacyDataInfo = () => {
  return (
    <div className='privacy-data-info-container'>
      <div className='privacy-data-info-header'>
        <h1 className='privacy-data-info-title '>Privacy & Data Protection</h1>
        <p className='privacy-data-info-subtitle cp-subtitle'>
          Your privacy is our priority. Learn how we collect, use, and protect your personal information.
        </p>
        {/* <div className='privacy-data-info-badge'>
          <span className='privacy-data-info-badge-text'>GDPR Compliant</span>
        </div> */}
      </div>

      <div className='privacy-data-info-content'>
        <section className='privacy-data-info-section'>
          <div className='privacy-data-info-section-header'>
            <div className='privacy-data-info-icon'>📊</div>
            <h3 className='privacy-data-info-section-title'>Data Collection</h3>
          </div>
          <div className='privacy-data-info-card'>
            <p className='privacy-data-info-text'>We collect information to provide better services to all our users. The data we collect includes:</p>
            <div className='privacy-data-info-grid'>
              <div className='privacy-data-info-item'>
                <h4 className='privacy-data-info-item-title'>Personal Information</h4>
                <ul className='privacy-data-info-list'>
                  <li className='privacy-data-info-list-item'>Name and contact details</li>
                  <li className='privacy-data-info-list-item'>Email address and phone number</li>
                  <li className='privacy-data-info-list-item'>Billing and payment information</li>
                </ul>
              </div>
              <div className='privacy-data-info-item'>
                <h4 className='privacy-data-info-item-title'>Usage Data</h4>
                <ul className='privacy-data-info-list'>
                  <li className='privacy-data-info-list-item'>Pages visited and time spent</li>
                  <li className='privacy-data-info-list-item'>Search queries and interactions</li>
                  <li className='privacy-data-info-list-item'>Device and browser information</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className='privacy-data-info-section'>
          <div className='privacy-data-info-section-header'>
            <div className='privacy-data-info-icon'>🎯</div>
            <h3 className='privacy-data-info-section-title'>How We Use Your Data</h3>
          </div>
          <div className='privacy-data-info-card'>
            <p className='privacy-data-info-text'>Your data helps us deliver and improve our services in the following ways:</p>
            <div className='privacy-data-info-purpose-grid'>
              <div className='privacy-data-info-purpose-card'>
                <div className='privacy-data-info-purpose-icon'>🚀</div>
                <h4 className='privacy-data-info-purpose-title'>Service Improvement</h4>
                <p className='privacy-data-info-purpose-text'>Enhance user experience and develop new features</p>
              </div>
              <div className='privacy-data-info-purpose-card'>
                <div className='privacy-data-info-purpose-icon'>🎨</div>
                <h4 className='privacy-data-info-purpose-title'>Personalization</h4>
                <p className='privacy-data-info-purpose-text'>Customize content and recommendations for you</p>
              </div>
              <div className='privacy-data-info-purpose-card'>
                <div className='privacy-data-info-purpose-icon'>📧</div>
                <h4 className='privacy-data-info-purpose-title'>Communication</h4>
                <p className='privacy-data-info-purpose-text'>Send important updates and service notifications</p>
              </div>
              <div className='privacy-data-info-purpose-card'>
                <div className='privacy-data-info-purpose-icon'>🔍</div>
                <h4 className='privacy-data-info-purpose-title'>Analytics</h4>
                <p className='privacy-data-info-purpose-text'>Understand usage patterns and optimize performance</p>
              </div>
            </div>
          </div>
        </section>

        <section className='privacy-data-info-section'>
          <div className='privacy-data-info-section-header'>
            <div className='privacy-data-info-icon'>🛡️</div>
            <h3 className='privacy-data-info-section-title'>Data Protection & Security</h3>
          </div>
          <div className='privacy-data-info-card'>
            <p className='privacy-data-info-text'>We implement comprehensive security measures to protect your personal information:</p>
            <div className='privacy-data-info-security-grid'>
              <div className='privacy-data-info-security-item'>
                <div className='privacy-data-info-security-icon'>🔐</div>
                <div className='privacy-data-info-security-content'>
                  <h4 className='privacy-data-info-security-title'>Encryption</h4>
                  <p className='privacy-data-info-security-text'>AES-256 encryption for data at rest and TLS 1.3 for data in transit</p>
                </div>
              </div>
              <div className='privacy-data-info-security-item'>
                <div className='privacy-data-info-security-icon'>🏗️</div>
                <div className='privacy-data-info-security-content'>
                  <h4 className='privacy-data-info-security-title'>Infrastructure</h4>
                  <p className='privacy-data-info-security-text'>SOC 2 Type II certified data centers with 24/7 monitoring</p>
                </div>
              </div>
              <div className='privacy-data-info-security-item'>
                <div className='privacy-data-info-security-icon'>👥</div>
                <div className='privacy-data-info-security-content'>
                  <h4 className='privacy-data-info-security-title'>Access Control</h4>
                  <p className='privacy-data-info-security-text'>Multi-factor authentication and role-based access controls</p>
                </div>
              </div>
              <div className='privacy-data-info-security-item'>
                <div className='privacy-data-info-security-icon'>🔄</div>
                <div className='privacy-data-info-security-content'>
                  <h4 className='privacy-data-info-security-title'>Regular Audits</h4>
                  <p className='privacy-data-info-security-text'>Quarterly security assessments and penetration testing</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='privacy-data-info-section'>
          <div className='privacy-data-info-section-header'>
            <div className='privacy-data-info-icon'>⚖️</div>
            <h3 className='privacy-data-info-section-title'>Your Rights & Control</h3>
          </div>
          <div className='privacy-data-info-card'>
            <p className='privacy-data-info-text'>You have complete control over your personal data. Here are your rights:</p>
            <div className='privacy-data-info-rights-grid'>
              <div className='privacy-data-info-right-item'>
                <div className='privacy-data-info-right-number'>1</div>
                <div className='privacy-data-info-right-content'>
                  <h4 className='privacy-data-info-right-title'>Right to Access</h4>
                  <p className='privacy-data-info-right-text'>Request a copy of all personal data we hold about you</p>
                </div>
              </div>
              <div className='privacy-data-info-right-item'>
                <div className='privacy-data-info-right-number'>2</div>
                <div className='privacy-data-info-right-content'>
                  <h4 className='privacy-data-info-right-title'>Right to Rectification</h4>
                  <p className='privacy-data-info-right-text'>Correct any inaccurate or incomplete information</p>
                </div>
              </div>
              <div className='privacy-data-info-right-item'>
                <div className='privacy-data-info-right-number'>3</div>
                <div className='privacy-data-info-right-content'>
                  <h4 className='privacy-data-info-right-title'>Right to Erasure</h4>
                  <p className='privacy-data-info-right-text'>Request deletion of your personal data ("right to be forgotten")</p>
                </div>
              </div>
              <div className='privacy-data-info-right-item'>
                <div className='privacy-data-info-right-number'>4</div>
                <div className='privacy-data-info-right-content'>
                  <h4 className='privacy-data-info-right-title'>Right to Portability</h4>
                  <p className='privacy-data-info-right-text'>Export your data in a machine-readable format</p>
                </div>
              </div>
              <div className='privacy-data-info-right-item'>
                <div className='privacy-data-info-right-number'>5</div>
                <div className='privacy-data-info-right-content'>
                  <h4 className='privacy-data-info-right-title'>Right to Object</h4>
                  <p className='privacy-data-info-right-text'>Opt out of certain data processing activities</p>
                </div>
              </div>
              <div className='privacy-data-info-right-item'>
                <div className='privacy-data-info-right-number'>6</div>
                <div className='privacy-data-info-right-content'>
                  <h4 className='privacy-data-info-right-title'>Right to Restrict</h4>
                  <p className='privacy-data-info-right-text'>Limit how we process your personal information</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='privacy-data-info-section'>
          <div className='privacy-data-info-section-header'>
            <div className='privacy-data-info-icon'>🍪</div>
            <h3 className='privacy-data-info-section-title'>Cookies & Tracking</h3>
          </div>
          <div className='privacy-data-info-card'>
            <p className='privacy-data-info-text'>We use cookies and similar technologies to enhance your browsing experience:</p>
            <div className='privacy-data-info-cookie-types'>
              <div className='privacy-data-info-cookie-type'>
                <span className='privacy-data-info-cookie-label essential'>Essential</span>
                <span className='privacy-data-info-cookie-desc'>Required for basic site functionality</span>
              </div>
              <div className='privacy-data-info-cookie-type'>
                <span className='privacy-data-info-cookie-label analytics'>Analytics</span>
                <span className='privacy-data-info-cookie-desc'>Help us understand how you use our site</span>
              </div>
              <div className='privacy-data-info-cookie-type'>
                <span className='privacy-data-info-cookie-label marketing'>Marketing</span>
                <span className='privacy-data-info-cookie-desc'>Used to show you relevant advertisements</span>
              </div>
            </div>
          </div>
        </section>

        <div className='privacy-data-info-actions'>
          {/* <button className='privacy-data-info-btn privacy-data-info-btn-primary'>
            <span className='privacy-data-info-btn-icon'>📄</span>
            Download Full Privacy Policy
          </button> */}
          <button className='privacy-data-info-btn privacy-data-info-btn-secondary'>
            <span className='privacy-data-info-btn-icon'>😟</span>
            Delete My Account
          </button>
          {/*  <button className='privacy-data-info-btn privacy-data-info-btn-outline'>
            <span className='privacy-data-info-btn-icon'>📊</span>
            Request Data Export
          </button> */}
        </div>

        <div className='privacy-data-info-footer'>
          <div className='privacy-data-info-contact'>
            <h4 className='privacy-data-info-contact-title'>Questions about your privacy?</h4>
            <p className='privacy-data-info-contact-text'>
              Our Data Protection Officer is here to help.
              <a href='mailto:storelense@pragmasolutions.co' className='privacy-data-info-contact-link'>
                Contact our privacy team
              </a>
              or call us at
              <a href='tel:+23480159273522' className='privacy-data-info-contact-link'>
                +234 (801) 59273522
              </a>
            </p>
          </div>
          <div className='privacy-data-info-update'>
            <p className='privacy-data-info-update-text'>
              <strong>Last updated:</strong> December 26, 2024
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyDataInfo;
